import { render, staticRenderFns } from "./PatientMinInfoForm.vue?vue&type=template&id=2c876977&scoped=true"
import script from "./PatientMinInfoForm.vue?vue&type=script&lang=js"
export * from "./PatientMinInfoForm.vue?vue&type=script&lang=js"
import style0 from "./PatientMinInfoForm.vue?vue&type=style&index=0&id=2c876977&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c876977",
  null
  
)

export default component.exports